export const GET_ITEM_COUNT = 7;
export const VISIBILITY_TIMEOUT = 60 * 1000;
export const MAX_MEMORY_EVENTS = 500;
export const MAX_ATTEMPTS = 10;

/**
 * The EventCountGuards uses this EVENT_COUNT_LIMIT to limit the number of analytics events
 * stored in AWC resilienceDB.
 *
 * This is the maximum number of events allowed and the limit is shared between multiple products
 * if they are on the same-origin.
 */
 export const EVENT_COUNT_LIMIT: number = 5000;
